<ng-container>
  <div class="rs-fe" id="calldetailsTop"></div>
  <div class="row">
    <div class="small-12 columns">
      <h1>{{ 'bills.callDetails.headerTitle' | translate }}</h1>
    </div>
  </div>

  <div class="row">
    <div class="small-12 columns">
      <section class="rs-content-wrapper">
        <div class="rs-fe3"></div>

        <my-bill-back-button></my-bill-back-button>

        <!-- START - loading state -->
        <div
          class="row"
          *ngIf="callDetails === undefined || callDetails.isFetching"
        >
          <div
            class="rs-msgbox"
            data-alert
            aria-live="assertive"
            role="alertdialog"
          >
            <div class="rs-msgbox-title">
              {{ 'bills.callDetails.componentLoadingLabel' | translate }}
            </div>
            <div class="rs-msgbox-icon">
              <i class="icon-Information-box" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <!-- END - loading state -->

        <!-- START - error state -->

        <div class="row" *ngIf="hasError || is12MonthOldDocument">
          <div
            class="rs-msgbox"
            [ngClass]="{ 'rs-msgbox-error': hasError }"
            data-alert
            aria-live="assertive"
            role="alertdialog"
          >
            <div class="rs-msgbox-title" *ngIf="errorTitleTranslationKey">
              {{ errorTitleTranslationKey | translate }}
            </div>
            <div class="rs-msgbox-content">
              {{ errorContentTranslationKey | translate }}
              <div class="rs-me"></div>
            </div>
            <div class="rs-msgbox-icon">
              <i class="icon-Information-box" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <!-- END - error state -->

        <!-- START - header -->

        <div
          class="rs-flex-row rs-flex-middle"
          *ngIf="
            !hasError &&
            callDetails &&
            !callDetails.isFetching &&
            !is12MonthOldDocument
          "
        >
          <div class="rs-flex-columns rs-flex-grow">
            <!-- START - charged phone number selector -->

            <div class="rs-flex-row rs-flex-middle">
              <div class="rs-flex-columns">
                <p>
                  {{ 'bills.callDetails.showChargedNumberLabel' | translate }}
                </p>
              </div>
              <div class="rs-flex-columns">
                <select
                  [(ngModel)]="selectedPhoneNumber"
                  (ngModelChange)="onFilterValueSelected(true)"
                >
                  <option value="">
                    {{ 'bills.callDetails.allChargedNumbersLabel' | translate }}
                  </option>
                  <option
                    *ngFor="let phoneNumber of parseResult?.phoneNumbers"
                    [value]="phoneNumber"
                  >
                    {{ phoneNumber }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <!-- END - charged phone number selector -->

          <!-- START - Remove filter / Download / Print buttons  -->

          <div class="rs-flex-columns show-for-medium-up">
            <p>
              <a
                href="javascript:;"
                class="rs-margin-right2"
                *ngIf="hasOneFilterActive()"
                (click)="onFilterValueSelected(false)"
                data-tms-event="button-click"
                data-tms-button-zone="mybill.detail.table"
                data-tms-button-name="remove filters"
              >
                <i
                  class="icon-Remove-filter rs-txt-s7 rs-margin-right1"
                  aria-hidden="true"
                ></i
                >{{ 'bills.callDetails.resetFiltersLabel' | translate }}</a
              >
            </p>
            <p>
              <a
                href="javascript:;"
                class="rs-margin-right2"
                (click)="downloadCsv()"
                data-tms-event="button-click"
                data-tms-button-zone="mybill.detail.table"
                data-tms-button-name="download call details"
                [attr.data-tms-context]="documentId"
                [attr.data-tms-message-info]="billingAccountNumber"
              >
                <i
                  class="icon-Download rs-txt-s7 rs-margin-right1"
                  aria-hidden="true"
                ></i
                >{{ 'bills.callDetails.extractToExcelLabel' | translate }}
              </a>
            </p>
            <p>
              <a
                href="javascript:;"
                (click)="printCsv()"
                data-tms-event="button-click"
                data-tms-button-zone="mybill.detail.table"
                data-tms-button-name="print call details"
                [attr.data-tms-context]="documentId"
                [attr.data-tms-message-info]="billingAccountNumber"
              >
                <i
                  class="icon-Print rs-txt-s7 rs-margin-right1"
                  aria-hidden="true"
                ></i
                >{{ 'bills.callDetails.printLabel' | translate }}
              </a>
            </p>
          </div>

          <!-- END - Remove filter / Download / Print buttons  -->

          <!-- START - pagination -->

          <div class="rs-flex-columns show-for-medium-up">
            <div class="rs-flex-row rs-flex-middle">
              <div class="rs-flex-column rs-flex-shrink">
                <p
                  (click)="setPage(pager.currentPage - 1)"
                  style="cursor: pointer"
                >
                  <i
                    class="icon-Arrow-left rs-txt-primary"
                    aria-hidden="true"
                  ></i>
                </p>
              </div>
              <div class="rs-flex-column rs-flex-shrink">
                <div class="panel rs-no-padding rs-wd-s4">
                  <input
                    type="number"
                    [(ngModel)]="selectedPageNumber"
                    (ngModelChange)="handlePageNumberChange()"
                    [value]="pager.currentPage"
                    class="text-center"
                  />
                </div>
              </div>
              <div class="rs-flex-column rs-flex-shrink">
                <p>
                  {{ 'bills.callDetails.ofLabel' | translate }}
                  {{ numberOfPages }}
                </p>
              </div>
              <div class="rs-flex-column rs-flex-shrink">
                <p
                  (click)="setPage(pager.currentPage + 1)"
                  style="cursor: pointer"
                >
                  <i class="icon-Arrow rs-txt-primary" aria-hidden="true"></i>
                </p>
              </div>
            </div>
          </div>

          <!-- END - pagination -->
        </div>

        <!-- END - header -->

        <div class="rs-me"></div>

        <!-- START - table -->

        <div
          class="row"
          id="printableDiv"
          *ngIf="
            !hasError &&
            callDetails &&
            !callDetails.isFetching &&
            !is12MonthOldDocument
          "
        >
          <div class="rs-table-data">
            <div class="rs-scroll-h">
              <table class="rs-table rs-table-zebra">
                <thead>
                  <tr>
                    <th
                      *ngIf="columnIsNotEmpty(COLUMN_INDEXES.CHARGED_NUMBER)"
                      class="hide-for-small-only"
                      scope="col"
                    >
                      {{ 'bills.callDetails.chargedNumberLabel' | translate }}
                    </th>
                    <th
                      class="rs-no-padding"
                      *ngIf="columnIsNotEmpty(COLUMN_INDEXES.CALL_CATEGORY)"
                      scope="col"
                    >
                      <div class="rs-pos-rel">
                        <i
                          class="icon-Arrow-down rs-pos-tr rs-margin-top1 rs-margin-right1"
                          aria-hidden="true"
                        ></i>
                        <select
                          [(ngModel)]="selectedCallCategory"
                          (ngModelChange)="onFilterValueSelected(true)"
                          class="rs-no-margin rs-txt-s3 rs-txt-primary rs-no-bg rs-no-border-h rs-no-border-v rs-clickable rs-pos-tr"
                        >
                          <option value="">
                            {{
                              'bills.callDetails.callCategoryLabel' | translate
                            }}
                          </option>
                          <option
                            *ngFor="
                              let callCategory of parseResult?.callCategories
                            "
                            [value]="callCategory"
                          >
                            {{ callCategory }}
                          </option>
                        </select>
                      </div>
                    </th>
                    <th
                      class="hide-for-small-only"
                      *ngIf="columnIsNotEmpty(COLUMN_INDEXES.CALL_TYPE)"
                      scope="col"
                    >
                      {{ 'bills.callDetails.callTypeLabel' | translate }}
                    </th>
                    <th
                      class="hide-for-small-only"
                      *ngIf="columnIsNotEmpty(COLUMN_INDEXES.CALLED_NUMBER)"
                      scope="col"
                    >
                      {{ 'bills.callDetails.calledNumberLabel' | translate }}
                    </th>
                    <th
                      class="hide-for-small-only"
                      *ngIf="
                        columnIsNotEmpty(COLUMN_INDEXES.CALL_ORIGIN) &&
                        columnIsNotEmpty(COLUMN_INDEXES.DESTINATION)
                      "
                      scope="col"
                    >
                      {{ 'bills.callDetails.callOriginLabel' | translate }} /
                      {{ 'bills.callDetails.callDestinationLabel' | translate }}
                    </th>
                    <th
                      class="rs-no-padding"
                      *ngIf="columnIsNotEmpty(COLUMN_INDEXES.DATE)"
                      scope="col"
                    >
                      <div class="rs-pos-rel">
                        <i
                          class="icon-Arrow-down rs-pos-tr rs-margin-top1 rs-margin-right1"
                          aria-hidden="true"
                        ></i>
                        <select
                          [(ngModel)]="selectedDate"
                          (ngModelChange)="onFilterValueSelected(true)"
                          class="rs-no-margin rs-txt-s3 rs-txt-primary rs-no-bg rs-no-border-h rs-no-border-v rs-clickable rs-pos-tr"
                        >
                          <option value="">
                            {{ 'bills.callDetails.dateLabel' | translate }}
                          </option>
                          <option *ngFor="let date of parseResult?.dates">
                            {{ date }}
                          </option>
                        </select>
                      </div>
                    </th>
                    <th
                      *ngIf="columnIsNotEmpty(COLUMN_INDEXES.START_TIME)"
                      scope="col"
                    >
                      {{ 'bills.callDetails.startTimeLabel' | translate }}
                    </th>
                    <th
                      class="hide-for-small-only"
                      scope="col"
                      *ngIf="columnIsNotEmpty(COLUMN_INDEXES.DURATION)"
                    >
                      {{ 'bills.callDetails.durationLabel' | translate }}
                    </th>
                    <th
                      class="rs-no-padding panel rs-wd-s10"
                      scope="col"
                      *ngIf="columnIsNotEmpty(COLUMN_INDEXES.AMOUNT)"
                    >
                      <div class="rs-pos-rel">
                        <i
                          class="icon-Arrow-down rs-pos-tr rs-margin-top1 rs-margin-right1"
                          aria-hidden="true"
                        ></i>
                        <select
                          [(ngModel)]="selectedAmountFilter"
                          (ngModelChange)="onFilterValueSelected(true)"
                          class="rs-no-margin rs-txt-s3 rs-txt-primary rs-no-bg rs-no-border-h rs-no-border-v rs-clickable rs-pos-tr"
                        >
                          <option value="">
                            {{ 'bills.callDetails.amountLabel' | translate }}
                          </option>
                          <option value="zero">= €0</option>
                          <option value="not-zero">≠ €0</option>
                        </select>
                      </div>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let row of pagedRows">
                    <td
                      class="hide-for-small-only"
                      *ngIf="columnIsNotEmpty(COLUMN_INDEXES.CHARGED_NUMBER)"
                    >
                      <span
                        *ngIf="row[COLUMN_INDEXES.CHARGED_NUMBER]"
                        class="rs-txt-s3"
                        >{{
                          row[COLUMN_INDEXES.CHARGED_NUMBER] | summary
                        }}</span
                      >
                    </td>
                    <td *ngIf="columnIsNotEmpty(COLUMN_INDEXES.CALL_CATEGORY)">
                      <span
                        *ngIf="row[COLUMN_INDEXES.CALL_CATEGORY]"
                        class="rs-txt-s3"
                        >{{ row[COLUMN_INDEXES.CALL_CATEGORY] }}</span
                      >
                    </td>
                    <td
                      class="hide-for-small-only"
                      *ngIf="columnIsNotEmpty(COLUMN_INDEXES.CALL_TYPE)"
                    >
                      <span
                        *ngIf="row[COLUMN_INDEXES.CALL_TYPE]"
                        class="rs-txt-s3"
                        >{{ row[COLUMN_INDEXES.CALL_TYPE] }}</span
                      >
                    </td>
                    <td
                      class="rs-nowrap hide-for-small-only"
                      *ngIf="columnIsNotEmpty(COLUMN_INDEXES.CALLED_NUMBER)"
                    >
                      <span
                        *ngIf="
                          row[COLUMN_INDEXES.CALLED_NUMBER] &&
                          isValueContainedInForwardToVoiceMailCodes(
                            row[COLUMN_INDEXES.CALLED_NUMBER]
                          )
                        "
                        class="rs-txt-s3"
                        >{{
                          getTranslatedLabelForForwardToVoiceMailCode(
                            row[COLUMN_INDEXES.CALLED_NUMBER]
                          )
                        }}</span
                      >
                      <span
                        *ngIf="
                          row[COLUMN_INDEXES.CALLED_NUMBER] &&
                          !isValueContainedInForwardToVoiceMailCodes(
                            row[COLUMN_INDEXES.CALLED_NUMBER]
                          )
                        "
                        class="rs-txt-s3"
                        >{{ row[COLUMN_INDEXES.CALLED_NUMBER] | summary }}</span
                      >
                    </td>
                    <td
                      class="hide-for-small-only"
                      *ngIf="
                        columnIsNotEmpty(COLUMN_INDEXES.CALL_ORIGIN) &&
                        columnIsNotEmpty(COLUMN_INDEXES.DESTINATION)
                      "
                    >
                      <span
                        *ngIf="
                          row[COLUMN_INDEXES.CALL_ORIGIN] &&
                          row[COLUMN_INDEXES.DESTINATION]
                        "
                        class="rs-txt-s3"
                        >{{ row[COLUMN_INDEXES.CALL_ORIGIN] | summary }} /
                        {{ row[COLUMN_INDEXES.DESTINATION] | summary }}</span
                      >
                    </td>
                    <td *ngIf="columnIsNotEmpty(COLUMN_INDEXES.DATE)">
                      <span
                        *ngIf="row[COLUMN_INDEXES.DATE]"
                        class="rs-txt-s3"
                        >{{ row[COLUMN_INDEXES.DATE] }}</span
                      >
                    </td>
                    <td *ngIf="columnIsNotEmpty(COLUMN_INDEXES.START_TIME)">
                      <span
                        *ngIf="row[COLUMN_INDEXES.START_TIME]"
                        class="rs-txt-s3"
                        >{{ row[COLUMN_INDEXES.START_TIME] }}</span
                      >
                    </td>
                    <td
                      class="hide-for-small-only"
                      *ngIf="columnIsNotEmpty(COLUMN_INDEXES.DURATION)"
                    >
                      <span
                        *ngIf="row[COLUMN_INDEXES.DURATION]"
                        class="rs-txt-s3"
                        >{{
                          row[COLUMN_INDEXES.DURATION] | summaryDuration
                        }}</span
                      >
                    </td>
                    <td *ngIf="columnIsNotEmpty(COLUMN_INDEXES.AMOUNT)">
                      <span
                        class="rs-txt-s3"
                        *ngIf="row[COLUMN_INDEXES.AMOUNT]"
                      >
                        <px-currency-amount
                          [amount]="
                            row[COLUMN_INDEXES.AMOUNT].replace(',', '.')
                              | summaryAmount
                          "
                        >
                        </px-currency-amount>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- END - table -->

        <!-- START - footer -->
        <div
          class="rs-flex-row rs-flex-middle"
          *ngIf="
            !hasError &&
            callDetails &&
            !callDetails.isFetching &&
            !is12MonthOldDocument
          "
        >
          <div class="rs-flex-columns hide-for-small-only">
            <small class="rs-font-pxL rs-block">{{ vatLabel }}</small>
          </div>
          <div class="rs-flex-columns rs-flex-grow">
            <div
              class="rs-flex-row rs-flex-middle rs-justify-center rs-justify-right-medium"
            >
              <div class="rs-flex-column rs-flex-shrink">
                <p
                  (click)="setPage(pager.currentPage - 1)"
                  style="cursor: pointer"
                >
                  <i
                    class="icon-Arrow-left rs-txt-primary"
                    aria-hidden="true"
                  ></i>
                </p>
              </div>
              <div class="rs-flex-column rs-flex-shrink">
                <div class="panel rs-no-padding rs-wd-s4">
                  <input
                    type="number"
                    [(ngModel)]="selectedPageNumber"
                    (ngModelChange)="handlePageNumberChange()"
                    [value]="pager.currentPage"
                    class="text-center"
                  />
                </div>
              </div>
              <div class="rs-flex-column rs-flex-shrink">
                <p>
                  {{ 'bills.callDetails.ofLabel' | translate }}
                  {{ numberOfPages }}
                </p>
              </div>
              <div class="rs-flex-column rs-flex-shrink">
                <p
                  (click)="setPage(pager.currentPage + 1)"
                  style="cursor: pointer"
                >
                  <i class="icon-Arrow rs-txt-primary" aria-hidden="true"></i>
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- END - footer -->

        <!-- START - FAQ -->
        <div [innerHtml]="faqHtml"></div>
        <!-- END - FAQ -->
      </section>
    </div>
  </div>
</ng-container>
